module.exports = __webpack_public_path__ + "media/images/icons/verified-315d13eee60fec87067672e1955c6080.png";